import React, { useState } from 'react';
import { FaCar } from 'react-icons/fa';
import suvImage from '../data/images/suv.png';
import etiosImage from '../data/images/etios.png';
import './VehicleTariffCards.css';

const VehicleTariffCards = () => {
  const [imageErrors, setImageErrors] = useState({});

  const vehicles = [
    {
      id: 'sedan',
      name: 'SEDAN',
      oneWay: 14,
      roundTrip: 13,
      image: '/images/vehicles/sedan.png',
      description: 'Swift Dzire Toyota Etios Tata Zest Hyundai Xcent Nissan Sunny anyone will be assigned',
      capacity: 'MAXIMUM 4 PASSENGER CAPACITY FOR SEDAN'
    },
    {
      id: 'etios',
      name: 'ETIOS',
      oneWay: 14,
      roundTrip: 13,
      image: etiosImage,
      description: 'Toyota Etios specifically assigned for comfortable travel',
      capacity: 'MAXIMUM 4 PASSENGER CAPACITY FOR ETIOS'
    },
    {
      id: 'suv',
      name: 'SUV',
      oneWay: 19,
      roundTrip: 18,
      image: suvImage,
      description: 'Innova Xylo Ertiga any one will be assigned',
      capacity: 'MAXIMUM 6 PASSENGER CAPACITY FOR SUV'
    },
    {
      id: 'innova',
      name: 'INNOVA',
      oneWay: 20,
      roundTrip: 18,
      image: '/images/vehicles/innova.jpg',
      description: 'Toyota Innova specifically assigned for premium travel',
      capacity: 'MAXIMUM 7 PASSENGER CAPACITY FOR INNOVA'
    }
  ];

  const handleImageError = (vehicleId) => {
    setImageErrors(prev => ({
      ...prev,
      [vehicleId]: true
    }));
  };

  return (
    <div id="vehicles-section" className="vehicle-tariff-cards">
      <div className="tariff-cards-container">
        <h2 className="tariff-cards-title">Outstation Tariff Rates</h2>
        
        <div className="vehicle-grid">
          {vehicles.map((vehicle) => (
            <div key={vehicle.id} className="vehicle-card">
              <h3 className="vehicle-name">{vehicle.name}</h3>
              <div className="vehicle-icon">
                {!imageErrors[vehicle.id] ? (
                  <img
                    src={vehicle.image}
                    alt={vehicle.name}
                    className="vehicle-image"
                    onError={() => handleImageError(vehicle.id)}
                  />
                ) : (
                  <FaCar className="icon fallback-icon" />
                )}
              </div>
              <div className="pricing">
                <div className="price-item">
                  <span className="price-label">ONE WAY</span>
                  <span className="price-value">₹ {vehicle.oneWay}/ km</span>
                </div>
                <div className="price-item">
                  <span className="price-label">ROUND TRIP</span>
                  <span className="price-value">₹ {vehicle.roundTrip}/ km</span>
                </div>
              </div>
              <div className="additional-info">
                <p className="vehicle-description">{vehicle.description}</p>
                <p className="vehicle-capacity">{vehicle.capacity}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default VehicleTariffCards;